if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = document.querySelectorAll('.side-panel-links--link');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.loftDrawer = document.getElementById('Product-Availability-Drawer');
      this.stockContainer = document.getElementById("loft-stock");
      this.panels = this.drawer.querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }

    connectedCallback() {
      console.log("✅ ProductSidePanelLinks est instancié !");
      this.setupObservers();
      this.preloadStockData();
    }

    preloadStockData() {
      console.log("🚀 Préchargement du stock en arrière-plan...");
      this.fetchStockData();
    }

    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', async (e) => {
          e.preventDefault();
          console.log("🛑 Bouton cliqué :", item);

          if (item.classList.contains('availability-button')) {
            console.log("🏬 Affichage du panneau 'Disponibilité au Loft'");
            this.drawer.classList.remove('active');
            this.body.classList.add('open-cc');
            this.loftDrawer.classList.add('active');

            console.log("📡 Appel API pour récupérer le stock...");
            await this.fetchStockData();
            return;
          }

          this.body.classList.add('open-cc');
          this.drawer.classList.add('active');

          const targetId = item.getAttribute('data-target');
          if (targetId) {
            console.log("🔍 Ouverture via data-target :", targetId);
            this.panels.forEach(panel => panel.classList.remove('tab-active'));
            const targetPanel = document.getElementById(targetId);
            if (targetPanel) {
              console.log("✅ Panneau trouvé :", targetPanel);
              targetPanel.classList.add('tab-active');
            } else {
              console.log("❌ Panneau non trouvé !");
            }
          } else {
            console.log("🔄 Ouverture via l’index :", i);
            this.panels.forEach(panel => panel.classList.remove('tab-active'));
            if (this.panels[i]) {
              this.panels[i].classList.add('tab-active');
            }
          }
        });
      });
    }

    async fetchStockData() {
      const productElement = document.querySelector("[data-product-id]");
      if (!productElement) {
        console.warn("⚠️ Élément data-product-id non trouvé.");
        return;
      }

      const productId = productElement.getAttribute("data-product-id");
      if (!productId) {
        console.warn("⚠️ Aucun ID produit trouvé.");
        return;
      }

      console.log("🆔 ID du produit détecté :", productId);

      try {
        const response = await fetch(`https://bylouise.fly.dev/api/stock/${productId}`);

        if (!response.ok) {
          throw new Error(`Erreur API Stock: ${response.status}`);
        }

        const stockData = await response.json();
        console.log("📦 Réponse API Stock :", stockData);

        if (!stockData || !Array.isArray(stockData.stock)) {
          console.error("❌ Erreur: API ne retourne pas un tableau valide !", stockData);
          this.stockContainer.innerHTML = "<p>Erreur de récupération du stock</p>";
          return;
        }

        this.displayStock(stockData.stock);
      } catch (error) {
        console.error("❌ Erreur lors de la récupération des stocks:", error);
        this.stockContainer.innerHTML = "<p>Impossible de récupérer les stocks</p>";
      }
    }

    displayStock(stockArray) {
        if (!this.stockContainer) {
            console.warn("⚠️ Conteneur stock non trouvé.");
            return;
        }

        // Sélection du paragraphe de description
        const loftDescription = document.querySelector(".loft-description");

        // 🔥 Vérifier si au moins une taille est disponible
        const hasStock = stockArray.some(item => item.stock > 0);

        // 🔥 Modifier le texte explicatif en fonction du stock disponible
        if (loftDescription) {
            loftDescription.textContent = hasStock
                ? "Voici les tailles disponibles pour cette pièce au Loft."
                : "Aucune taille disponible actuellement pour cette pièce.";
        }

        // 🔥 Affichage du stock ou message alternatif
       /* if (!hasStock) {
            this.stockContainer.innerHTML = "<p>Stock indisponible</p>";
            return;
        }*/

        let stockHTML = '<div class="loft-stock-container">';

        stockArray.forEach(item => {
            const stockClass = item.stock > 0 ? 'size-available' : 'size-unavailable';
            stockHTML += `<span class="${stockClass}">${item.title}</span>`;
        });

        stockHTML += "</div>";
        this.stockContainer.innerHTML = stockHTML;
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}
